import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[show-title]'
})
export class ShowTitleDirective implements AfterViewInit {

  @Input('show-title') enableTips: boolean;

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    if (this.enableTips) {
      this.el.nativeElement.title = this.el.nativeElement.innerText;
    }
  }

}
